import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

// 如果被复制的item，有key的话，需要对其进行重新赋值，避免key重复。
const formateItem = item => {
    if (item.key) {
        return { ...item, key: `${item.key}_clone` };
    } else {
        return item;
    }
};

const isClone = (index, content, extension) => {
    if (index < extension || index > content.length - 1 - extension) {
        return true;
    } else {
        return false;
    }
};

class List extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array.isRequired,
        unitSize: PropTypes.number.isRequired,
        tmpl: PropTypes.func.isRequired,
        axis: PropTypes.string.isRequired,
        extension: PropTypes.number.isRequired,
        current: PropTypes.number.isRequired,
    };
    static defaultProps = {};

    render() {
        const { content, unitSize, tmpl, axis, extension, current } = this.props;

        const begin = [];
        const end = [];

        for (let i = 0; i < extension; i++) {
            begin.unshift(formateItem(content[content.length - i - 1]));
            end.push(formateItem(content[i]));
        }

        const newContent = [...begin, ...content, ...end];

        const sizeType = axis === 'horizonta' ? 'width' : 'height';

        return [
            ...newContent.map((item, index) => (
                <div
                    key={item.key ? item.key : index}
                    ifeng_ui_pc_sliders-item={axis}
                    ifeng_ui_pc_slideers-current={current === index ? 'true' : 'false'}
                    style={{ [sizeType]: unitSize }}>
                    {tmpl(item, isClone(index, newContent, extension), index)}
                </div>
            )),
        ];
    }
}

export default List;
